module.exports = __webpack_public_path__ + "0bf2fc3236593529a0cf3d35b4a355aa.svg";